import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationNotesKey } from '@features/applicationNotes';
import { applicationNotesRoute } from '@features/applicationNotes/api/constants';
import { employerApplicationsKey, errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useCreateEnterpriseApplicationNoteProps = {
  company_id: number;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateEnterpriseApplicationNote = ({
  setErrorText = () => { },
}: useCreateEnterpriseApplicationNoteProps) => {
  const client = useQueryClient();
  const { mutate: createNote, isLoading: isCreateNoteLoading } = useMutation({
    mutationFn: (variables: {
      company_id: number,
      application_id: number;
      note: string;
      name: string;
    }) => {
      return axiosInstance
        .post(applicationNotesRoute, variables)
        .then((res) => res.data);
    },
    onSuccess: (data, variables) => {
      client.invalidateQueries([applicationNotesKey, variables.application_id]);
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    createNote,
    isCreateNoteLoading,
  };
};
